<template>
    <v-app-bar app color="white">

          <v-toolbar-title class="tool-bar-title headline" @click="goHome">
              Retail Execution Portal
          </v-toolbar-title>

          <v-spacer></v-spacer>

          <v-text-field
              class="text-field-search-header"
              v-model="search_msg"
              @keyup.enter="onChangeSearch()"
              placeholder="Search">
          </v-text-field>
        <v-menu  open-on-click offset-y >
            <template v-slot:activator="{ on, attr }">
                <v-btn dark icon class="btn-top" v-bind="attr" v-on="on">
                    <v-icon color="black" >chat</v-icon>
                </v-btn>
            </template>      
            <v-list>
            <v-list-item  @click="openURL('https://retailsolutions.force.com/s/contactsupport')">
            <v-list-item-title>Submit Request</v-list-item-title>
            </v-list-item>
            <v-list-item @click="openURL('https://retailsolutions.force.com/s/case/Case/Default')">
            <v-list-item-title>My Requests</v-list-item-title>
            </v-list-item>
            </v-list>   
        </v-menu>
         
        <v-badge
        :content="newNotificationNumber"
        :value="newNotificationNumber"
        @click.native="onShowNotificationPanel"
        color="red"
        style="margin-right: 24px;"
        overlap
      >

           <v-icon color="grey darken-4"
              @click="onShowNotificationPanel">
               notifications
            </v-icon>
            
          </v-badge>

        <v-avatar
          @click.stop="onShowUserSettingsDialog"
          size="36"
          class="avatar-tool-bar blue-grey darken-2 orange--text app-settings" >
          <span>{{ userLetter }}</span>
        </v-avatar>

      </v-app-bar>
</template>
<script>
export default {
    name:"AppHeader",
    computed: {
        userLetter() {
            const user = this.$store.getters.getUserInfo;
            return user != null ? user.name[0] : "";
        },
        newNotificationNumber(){
            const number =  this.$store.getters.getNewNotificationNumber;
            return number > 99 ?"99+":number;
        }
    },
    data() {
        return {
            search_msg: ""
        };
    },
    methods:{
        onChangeSearch() {
            console.log("onChangeSearch(search): ", this.search_msg);
            this.openURL("https://retailsolutions.force.com/s/global-search/"+this.search_msg);
        },
        onShowNotificationPanel() {
            this.$emit("onShowNotificationPanel");
        },
        onShowUserSettingsDialog() {
            this.$emit("onShowUserSettingsDialog");
        },
        openURL(url){
            window.open(url, "_blank");    
        },
        goHome(){
            this.$router.push("/");
        }
    }
}
</script>
<style lang="scss" scoped>
    .v-toolbar {
        left: 56px !important;
        box-shadow: none !important;
        -webkit-box-shadow:  none !important;
    }

    .tool-bar-title {
            margin-left: 24px;
            cursor:pointer;
    }
</style>